import { getHostName } from "../utils";

export async function fetchBoats() {
  const data = await fetch(`${getHostName()}/api/boats/?format=json`);
  return await data.json();
}
